import { getAll, put } from 'redux/api/Entities'
import * as SimRenaming from 'redux/api/SimRenamings'

import * as actions from './actions'

import { Dispatch } from 'redux'
import { PutEntityAttribute } from 'types/GlobalEntities'

import { useThunkActions } from 'redux/actions/useThunkActions'

import { toggleSnackbarOpen } from 'redux/actions/Snackbar'

import { SnackbarMessage } from 'types/GlobalSnackbar'

export function tryGetAllEntities() {
  return (dispatch: Dispatch) => {
    dispatch(actions.getAll())

    getAll()
      .then((response) => {
        dispatch(actions.getAllSuccess(response.data.data))
      })
      .catch(() => {
        dispatch(actions.getAllFailed())
      })
  }
}

function tryPutEntityAttributes(
  entityId: string,
  entityAttributes: PutEntityAttribute[]
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.putAttributes())

    put(entityId, entityAttributes)
      .then((response) => {
        dispatch(
          actions.putAttributesSuccess({
            data: response.data.data,
            entityId
          })
        )

        dispatch(toggleSnackbarOpen(SnackbarMessage.ColumnsUpdated))
      })
      .catch(() => {
        dispatch(actions.putAttributesFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.ColumnsUpdatedFailed))
      })
  }
}

function tryPutTerminology(
  body: SimRenaming.PutSimRenaming[],
  entityId: string
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.putTerminology())

    SimRenaming.put(body)
      .then((response) => {
        dispatch(
          actions.putTerminologySuccess({
            data: response.data.data,
            entityId
          })
        )
      })
      .catch(() => {
        dispatch(actions.putTerminologyFailed())
      })
  }
}

export const useEntityActions = () => {
  return {
    tryGetAllEntities: useThunkActions(tryGetAllEntities),
    tryPutEntityAttributes: useThunkActions(tryPutEntityAttributes),
    tryPutTerminology: useThunkActions(tryPutTerminology)
  }
}
